import styled from "styled-components";
import { theme } from "../../../theme";

/**
 * 모달 결과 인치 타이틀
 */
const BodyTypo = styled.div`
  ${theme.typo.body.r16};
  color: ${theme.colors.gray2};
`;
/**
 * 모달 결과 동의여부 타이틀
 */
const StatusTypo = styled.div<{ status?: boolean }>`
  ${theme.typo.heading.b16};
  color: ${({ status }) =>
    status === true
      ? theme.colors.blue2
      : status === false
      ? theme.colors.red3
      : theme.colors.gray2};
`;

export { BodyTypo, StatusTypo };
